import Papa from "papaparse";
import type { BikeWithLocation } from "../types/bike";

export interface VehicleCsvLookups {
  categoryNameById: Map<string, string>;
  cityNameById: Map<string, string>;
}

export interface VehicleCsvRow {
  bike_sn: string;
  gps_device_id: string;
  category: string;
  main_city: string;
}

function formatIdForExcel(value: string | null | undefined): string {
  if (!value) {
    return "";
  }
  return `\t${value}`;
}

export function bikesToCsvRows(
  bikes: BikeWithLocation[],
  lookups: VehicleCsvLookups,
): VehicleCsvRow[] {
  return bikes.map((bike) => ({
    bike_sn: formatIdForExcel(bike.bike_sn),
    gps_device_id: formatIdForExcel(bike.bike_id),
    category: bike.category_id
      ? (lookups.categoryNameById.get(bike.category_id) ?? bike.category_id)
      : "",
    main_city: bike.primary_city_id
      ? (lookups.cityNameById.get(bike.primary_city_id) ?? bike.primary_city_id)
      : "",
  }));
}

export function bikesToCsv(
  bikes: BikeWithLocation[],
  lookups: VehicleCsvLookups,
): string {
  const rows = bikesToCsvRows(bikes, lookups);
  const csv = Papa.unparse(rows, {
    columns: ["bike_sn", "gps_device_id", "category", "main_city"],
    header: true,
    quotes: true,
  });
  return `\uFEFF${csv}`;
}

export function getVehicleCsvFilename(date = new Date()): string {
  const datePart = date.toISOString().slice(0, 10);
  return `vehicles-${datePart}.csv`;
}
